import React, { useState, useEffect, useContext } from "react";
import { DescriptionList, EmptyState, Loader } from "../../../../ui";
import { Callout } from "./ui-pending";
import "./aeForm.scss";
import { aeForm } from "../../../../Api/apiUtils";
import { PaymentConfigContext } from '../../../../Api/global/ApiContext';

interface AeProps {
  studentId: string;
}

const NewAeForm: React.FC<AeProps> = ({ studentId }) => {
  const [aeList, setAeList] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const paymentConfig = useContext(PaymentConfigContext);
  const oldCourseLevelMapping = paymentConfig?.OldCourseLevelMapping || [[]];

  useEffect(() => {
    fetchAeDetails();
  }, [studentId]);

  const fetchAeDetails = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await aeForm(studentId);
      if (response && response.length > 0) {
        let rId = response[0]?.recommendedPaidCourseId;
        if (rId) {
          if (+rId < 500) {
            let courseObj = oldCourseLevelMapping[0].find((e: any) => e.id == +rId);
            if (courseObj) {
              response[0]._recommendedCourseName = courseObj.name;
              response[0]._recommendedCourseLevel = courseObj.level;
            }
          } else {
            let courseObj = oldCourseLevelMapping[0].find((e: any) => e.levelId == rId.toString());
            if (courseObj) {
              response[0]._recommendedCourseName = courseObj.name;
              response[0]._recommendedCourseLevel = courseObj.level;
            }
          }
        }
        setAeList(response[0]);
      } else {
        setError("No assessment data available");
      }
    } catch (error) {
      console.error("Error fetching AE details:", error);
      setError("Failed to fetch AE form data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loader label="Loading assessment…" />;
  }

  if (error) {
    return <Callout tone="danger">{error}</Callout>;
  }

  if (!aeList || !aeList.feedbacks) {
    return (
      <EmptyState
        title="No assessment data available"
        description="This student has no assessment (AE) form on record yet."
      />
    );
  }

  return (
    <div className="ds-stack ae-form">
      <DescriptionList
        items={[
          { label: "Assessment by", value: aeList?.teacherName },
          ...(aeList?._recommendedCourseName
            ? [{ label: "Recommended course", value: aeList._recommendedCourseName }]
            : []),
          ...(aeList?._recommendedCourseLevel
            ? [{ label: "Recommended level", value: aeList._recommendedCourseLevel }]
            : []),
        ]}
      />
      <ol className="ae-form__list">
        {aeList.feedbacks
          .filter((item: any) => item.question !== "courseId")
          .map((item: any, index: number) => (
            <li key={index} className="ae-form__item">
              <span className="ds-strong">
                {index + 1}. {item.question}
              </span>
              <p className="ae-form__answer ds-text-muted">{item.option}</p>
            </li>
          ))}
      </ol>
    </div>
  );
};

export default NewAeForm;